import { render, staticRenderFns } from "./DashboardVideoView.vue?vue&type=template&id=57f9e906&scoped=true&"
import script from "./DashboardVideoView.vue?vue&type=script&lang=js&"
export * from "./DashboardVideoView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardVideoView.vue?vue&type=style&index=0&id=57f9e906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f9e906",
  null
  
)

/* custom blocks */
import block0 from "./DashboardVideoView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports